import {
  loadFeedData,
  pinnedNames,
  storeFeedSections,
} from 'src/components/navigation/feed_store.js'
import { pinnedFeeds } from 'src/components/navigation/feeds.js'
import { routeTo } from 'src/components/navigation/navigation.js'

import { useUsersStore } from 'src/stores/users.js'

// The pinned feeds as icons next to the timeline header's title: one click
// to switch between the feeds used most
export default {
  created() {
    loadFeedData()
  },
  methods: {
    // the router's exact match leaves out the query (favorites are a tab
    // of the profile)
    isCurrent({ to }, isExactActive) {
      const query = to.query || {}
      return (
        isExactActive &&
        Object.entries(query).every(([k, v]) => this.$route.query[k] === v)
      )
    },
  },
  computed: {
    feeds() {
      const user = useUsersStore().currentUser
      if (!user) return []
      return pinnedFeeds(pinnedNames(), storeFeedSections()).map((item) => ({
        ...item,
        to: routeTo(item, user),
      }))
    },
  },
}
